/**
 * Created by Eran.Shain on 11/24/2016.
 */
import type { IWidget } from "../widget-types/types";
import type { IDataFetcher, IDataFetcherFactory } from "./IDataFetcher";
import resourceRegistry from "app/common/resources/resourceRegistry";
import {
    fetchWithFullResponseConfig,
    fetchWithFullResponseInterceptorHandlers,
} from "app/components/widget/widget-fetchers/DefaultDataFetcher";

class InjectionWidgetFetcherFactory<T> implements IDataFetcherFactory<T> {
    create(widget: IWidget<T>): IDataFetcher<T> {
        const { properties } = widget.getWidgetConfig();
        const resourceObj = resourceRegistry[properties.resource];
        const resource = resourceObj[properties.method];
        return {
            fetch: () =>
                resource(widget.apiParams, fetchWithFullResponseConfig).then(
                    ...fetchWithFullResponseInterceptorHandlers,
                ),
            destroy: () => undefined,
        };
    }
}

export default new InjectionWidgetFetcherFactory();
